import {
  ChangeDetectorRef,
  Directive,
  Input,
  TemplateRef,
  ViewContainerRef,
  inject,
} from '@angular/core';
import { UserRole } from '@app/features/users/user.model';
import { IAuthenticatedUserService } from '@app/shared/auth/authenticated-user-service/authenticated-user-service';
import { AUTHENTICATED_USER_SERVICE } from '@app/shared/auth/authenticated-user-service/authenticated-user-service.token';

@Directive({
  selector: '[appHasRole]',
  standalone: true,
})
export class HasRoleDirective {
  private readonly authenticatedUserService = inject(
    AUTHENTICATED_USER_SERVICE,
  ) as IAuthenticatedUserService;

  private readonly cdr = inject(ChangeDetectorRef);
  private readonly viewContainerRef = inject(ViewContainerRef);
  private readonly templateRef = inject(TemplateRef<unknown>);
  private hasView = false;

  @Input()
  set appHasRole(roles: UserRole[]) {
    const hasRole = roles?.length ? this.authenticatedUserService.hasAnyRole(roles) : false;
    if (hasRole && !this.hasView) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
      this.hasView = true;
    }

    if (!hasRole && this.hasView) {
      this.viewContainerRef.clear();
      this.hasView = false;
    }
    this.cdr.markForCheck();
  }
}
